import { createAction, props } from '@ngrx/store';
import { ForceFolder, ForceOrganisationDocument, ForceOrganisationItem, ForceOrganisationViewMode } from '../models';

export const setForceOrganisation = createAction(
    '[ForceOrganisation] setForceOrganisation',
    props<{ doc: ForceOrganisationDocument }>()
);

export const clearForceOrganisation = createAction('[ForceOrganisation] clearForceOrganisation');

export const setViewMode = createAction(
    '[ForceOrganisation] setViewMode',
    props<{ gameId: string; mode: ForceOrganisationViewMode }>()
);

export const setFolders = createAction(
    '[ForceOrganisation] setFolders',
    props<{ gameId: string; folders: ForceFolder[] }>()
);

export const setItems = createAction(
    '[ForceOrganisation] setItems',
    props<{ gameId: string; items: ForceOrganisationItem[] }>()
);
